import { isRouteErrorResponse, useRevalidator } from 'react-router'
import { ContentError } from '@/components/ContentError'
import {
  JobShortIdLookupError,
  JobShortIdNotFoundError,
} from '@/features/jobs/job-short-id'

export interface JobErrorContainerProps {
  error: unknown
}

/**
 * Shows why a job could not be loaded.
 */
export function JobErrorContainer({ error }: JobErrorContainerProps) {
  const { revalidate } = useRevalidator()

  if (error instanceof JobShortIdNotFoundError) {
    return <ContentError title="Job not found" error={error.message} />
  }

  if (error instanceof JobShortIdLookupError) {
    return (
      <ContentError
        title="Couldn't load job"
        error={error.cause}
        onRetry={revalidate}
      />
    )
  }

  if (isRouteErrorResponse(error) && error.status === 404) {
    return (
      <ContentError
        title="Job not found"
        error="This job does not exist or was deleted."
      />
    )
  }

  return <ContentError error={error} onRetry={revalidate} />
}
